import classnames from "classnames";
import { observer } from "mobx-react";
import React from "react";
import { useLiveMatchResult } from "@state/hooks/offer/useLiveMatchResult";
import { useOfferOptionsContext } from "@state/hooks/offer/useOfferOptionsContext";

export const LiveMatchResult = observer(function LiveMatchResult(props: {
	event: Parameters<typeof useLiveMatchResult>[0];
	sport: Parameters<typeof useLiveMatchResult>[1];
	isSpotlight?: boolean;
}) {
	const options = useOfferOptionsContext();

	const { isScore, home, away } = useLiveMatchResult(
		props.event,
		props.sport,
		options
	);

	if (props.isSpotlight) {
		return (
			<>
				<div className="spotlight__match__home">{home}</div>
				<div className="spotlight__match__away">{away}</div>
			</>
		);
	}

	return (
		<div className={classnames("match__result", { "is-score": isScore })}>
			<div>{home}</div>
			<div>{away}</div>
		</div>
	);
});
